module.exports = __webpack_public_path__ + "static/media/remote-sos.ed45cbca.svg";